import { useQuery } from '@tanstack/react-query';
import { apiGet } from './_base';
import { useAuthStore } from '@/store/auth';

export type UserBalanceDto = {
  cash_balance: number;
  bonus_balance: number;
  cash_withdrawal_limit: number;
  bonus_withdrawal_limit: number;
  xp: number;
  mission_points: number;
  vip: number;
};

export function useBalanceQuery() {
  const isAuthed = useAuthStore((s) => s.isAuthed());
  return useQuery({
    queryKey: ['user', 'balance'],
    queryFn: () => apiGet<UserBalanceDto>('/api/v1/user/balance'),
    enabled: isAuthed,
  });
}
